<template>
  <div class="shop-offers-base">
    <div class="l-container">
      <div class="header-title-wrap-bc title-wrap">
        <h2 class="text-h2-bold-up desktop-margin">Все товары</h2>
        <span class="tablet-count text-body-m-book desktop-margin">
          {{ count && tabletCount }}
        </span>
        <HowToBuy class="how-modal-button">
          <UiLink mode="button" responsive-ico icon-after="help-circle">
            Как купить товар
          </UiLink>
        </HowToBuy>
      </div>
    </div>

    <ListingsProductsWithFilters
      v-model:count="count"
      :data="data"
      :page-data="pageData"
      :show-more-button="false"
      :filters-url="`/shops/${data.shop_id}/filters`"
      :products-url="`/shops/${data.shop_id}/offers`"
      where-str="найдено"
      can-change-category
      type-page="shop"
      :sort-market="sortMarket"
      @change-data="(e) => $emit('change-data', e)"
    >
      <template #after-products>
        <ModelHistory />
      </template>
      <template #after-filters>
        <nuxt-link
          v-if="isPromocodes"
          :to="$route.path.replace('-tovary', '-skidki-promokody')"
          class="shop-promocodes text-button"
          @click="clearMobileScroll"
        >
          Промокоды магазина {{ data.h1.replace(/товары/i, '') }}
        </nuxt-link>
      </template>
    </ListingsProductsWithFilters>
  </div>
</template>

<script lang="ts" setup>
import type { DynamicPageContext } from '~/interfaces/api';
import { sortMarket } from '~/common/const';
import HowToBuy from '~/components/ui/HowToBuy.vue';
import UiLink from '~/components/ui/ui-link/ui-link.vue';
import numWord from '~/common/num-word';

const ModelHistory = defineAsyncComponent(
  () => import('~/components/model-history/ModelHistory.vue')
);
const props = defineProps({
  data: {
    type: Object as () => DynamicPageContext,
    required: true,
  },
  pageData: {
    type: Object as any,
    required: true,
  },
});
const count = computed(
  () => props.pageData?.count || props.pageData?.total || 0
);
const isPromocodes = computed(() => props.pageData?.promocodes?.length);
const tabletCount = computed<string>(() => {
  return numWord(
    count.value,
    ['', 'товар', 'товара', 'товаров'],
    true,
    true,
    true
  );
});
const clearMobileScroll = () => {
  document.body.classList.remove('tablet-overflow-hidden');
  document.body.style.paddingRight = '';
};
</script>
<style scoped lang="scss">
.shop-promocodes {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  @include md-block {
    padding-top: 24px;
    border-top: 1px solid $achromatic-hover;
    display: block;
  }
}

.title-wrap {
  h2 {
    display: inline;
    @include lg-block {
      display: initial;
    }
  }

  @include lg-block {
    display: inline-flex;
  }
}

.how-modal-button {
  margin-top: 4px;
  display: inline-flex;
  position: relative;
  width: 100%;
  @include lg-block {
    display: inline-flex;
    margin-top: 0;
    width: auto;
  }
}

.desktop-margin {
  margin-right: 8px;
}
</style>
